import { getWebPath } from '@doss/common-all'
import { Settings } from 'lucide-react'
import { Link } from 'react-router'
import { BreadcrumbObjectType, ChartType } from '../../common/generated/apollo-operations'

export function ChartDetailsActions({
  chartId,
  chartType,
}: {
  chartId?: string
  chartType?: ChartType
}) {
  if (!chartId) {
    return null
  }
  return (
    <Link
      className="flex cursor-pointer items-center justify-center rounded p-2 hover:bg-gray-2"
      onClick={(e) => e.stopPropagation()}
      to={getWebPath({
        objectType:
          chartType === ChartType.PIVOT_TABLE
            ? BreadcrumbObjectType.PIVOT_TABLE
            : BreadcrumbObjectType.CHART,
        objectId: chartId,
        settings: true,
      })}
    >
      <Settings size={16} />
    </Link>
  )
}
